"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCustomFilters = exports.toCustomFilterItems = exports.parseFilter = exports.includesTerm = exports.focusPrev = exports.focusNext = exports.filterHasNoEmptyConditions = exports.customFiltersItemsAreEquals = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _exchangeSearchCommon = require("@mulesoft/exchange-search-common");
var _types = require("./types");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const focusNext = (focusedItemIndex, elements) => {
  if (focusedItemIndex === -1 || focusedItemIndex === elements.length - 1) {
    elements[0].focus();
    return;
  }
  elements[focusedItemIndex + 1].focus();
};
exports.focusNext = focusNext;
const focusPrev = (focusedItemIndex, elements) => {
  if (focusedItemIndex === -1 || focusedItemIndex === 0) {
    elements[elements.length - 1].focus();
    return;
  }
  elements[focusedItemIndex - 1].focus();
};
exports.focusPrev = focusPrev;
const includesTerm = (value, searchTerm) => {
  return value.toLowerCase().includes(searchTerm.toLowerCase()) || searchTerm === '';
};

/**
 * Returns true when the given filter has no operator or value defined
 *
 * @param filter The custom field filter
 * @returns boolean
 */
exports.includesTerm = includesTerm;
const filterHasNoEmptyConditions = filter => {
  var _filter$customField;
  return [(_filter$customField = filter.customField) === null || _filter$customField === void 0 ? void 0 : _filter$customField.displayName, filter.operator, filter.value].every(value => value !== null && value !== undefined && value.length !== 0);
};
exports.filterHasNoEmptyConditions = filterHasNoEmptyConditions;
const toCustomFilterItem = ({
  customField,
  value,
  operator
}, key) => {
  return value.map(val => [customField.tagKey, val, operator, key].filter(Boolean).join(':'));
};
const getFilterKey = filter => `${filter.customField.tagKey}:${filter.operator}`;

/**
 * Transforms the given filters to ANG custom filter items
 *
 * @param filters The custom field filter conditions
 * @returns An array of ANG custom filter items
 */
const toCustomFilterItems = filters => {
  const groupedFiltersByKey = filters.filter(filterHasNoEmptyConditions).reduce((accum, filter) => {
    const key = getFilterKey(filter);
    if (accum[key]) {
      accum[key].push(filter);
      return accum;
    }
    return _objectSpread(_objectSpread({}, accum), {}, {
      [key]: [filter]
    });
  }, {});
  let index = 0;
  const getIndex = () => {
    index += 1;
    return index;
  };
  const values = filters.flatMap(filter => {
    const key = getFilterKey(filter);
    if (!groupedFiltersByKey[key]) {
      return [];
    }
    return toCustomFilterItem(filter, groupedFiltersByKey[key].length > 1 ? getIndex() : null);
  });
  return [{
    key: _exchangeSearchCommon.constants.CUSTOM_FIELDS_KEY,
    values
  }];
};
exports.toCustomFilterItems = toCustomFilterItems;
const parseFilter = (filter, facets) => {
  const {
    key: tagKey,
    value,
    operator: sourceOperator,
    identifier: sourceKey
  } = (0, _exchangeSearchCommon.parseCustomFieldFilter)(filter);
  if (!tagKey) {
    return null;
  }

  // validates value provided
  const customField = facets === null || facets === void 0 ? void 0 : facets.find(facet => {
    return facet.tagKey === tagKey;
  });
  const customFieldOperators = Object.values(_types.CustomFieldOperator);

  // validates that operator exists
  if (!customFieldOperators.includes(sourceOperator)) {
    return null;
  }
  const operator = sourceOperator;
  const keyNum = parseInt(sourceKey, 10);
  const key = Number.isNaN(keyNum) ? null : keyNum;
  return {
    tagKey,
    customField,
    operator,
    value,
    key
  };
};
exports.parseFilter = parseFilter;
const toCustomFilters = (values, facets) => {
  // structure of CustomFilterItem values is [tagKey:value:operator:key?] where last key is optional
  // some examples are
  // "Team:Exchange:eq:1"
  // "Team:CloudHub:eq:2"
  // "Rating:4:le"
  return values.reduce((accum, current) => {
    const currentFilter = parseFilter(current, facets);
    if (!(currentFilter !== null && currentFilter !== void 0 && currentFilter.customField)) {
      return accum;
    }
    const {
      tagKey,
      customField,
      key,
      operator,
      value
    } = currentFilter;

    // search if there is an existing filter with keys provided
    const existingFilter = accum.find(filter => filter.key === key && filter.operator === operator && filter.customField.tagKey === tagKey);
    if (existingFilter) {
      existingFilter.value.push(value);
      return accum;
    }
    return [...accum, {
      customField,
      operator,
      key,
      value: [value]
    }];
  }, []);
};
exports.toCustomFilters = toCustomFilters;
const filterItemsAreEquals = (previous, current) => {
  return previous.key === current.key && previous.values.length === current.values.length && previous.values.every((val, index) => val === current.values[index]);
};

/**
 * Returns true when the given custom filters items have
 * the same keys and values
 *
 * @param previous An ANG custom filter item
 * @param current ANG custom filter item to compare
 * @returns boolean
 */
const customFiltersItemsAreEquals = (previous, current) => {
  return previous.length === current.length && previous.every((prev, index) => filterItemsAreEquals(prev, current[index]));
};
exports.customFiltersItemsAreEquals = customFiltersItemsAreEquals;
//# sourceMappingURL=utils.js.map